<template>

<com-segment class="treatment" :title="(treatment) ? section.treatment[treatment].title : false" segment="treatment" :section="section" v-on:close="onCloseClick">

	<p v-if="!treatment && !$isPatient">{{ section.treatment.text }}</p>

	<com-more v-if="treatment" :section="section" :treatment="treatment" v-on:close="onCloseClick" v-on:next="$emit('next')" />

	<template v-if="!treatment && $isPatient && !showOther">

		<div class="treatment-patient">

			<div class="treatment-patient-text" v-html="parsedPatientText" v-on:click="onPatientTextClick"></div>

		</div>

	</template>

	<template v-if="!treatment && $isPatient && showOther">

		<div class="treatment-other">

			<p>These are some of the medicines available to strengthen bones. Click on each one if you would like to find out more. It is important to note that the medicines listed here are usually (at least initially) prescribed by hospital specialists and so your local GP, pharmacist or other primary care healthcare professional may not be able to offer these and/or answer questions about them. Also, there are some restrictions available on who is eligible for these medicines. For example, abaloparatide and romosozumab are not currently licensed for men. Drug availability is sometimes also an issue.</p>

			<div class="treatment-other-list">
				<div class="treatment-other-item" v-for="drug in otherDrugs" :key="drug" v-on:click="onMoreClick(drug)">{{ section.treatment[drug].title }}</div>
			</div>

		</div>

	</template>

	<template v-if="!treatment && !$isPatient">

	<div class="treatment-table" :class="{'has-scroll': treatments.length > 2, 'is-start': isStart, 'is-end': !isStart}" v-if="treatments.length">

		<div class="treatment-head">

			<div class="treatment-head-left" v-on:click="onLeftClick"></div>
		
			<div class="treatment-head-title">{{ section.treatment.table.title }}</div>

			<div class="treatment-head-right" v-on:click="onRightClick"></div>

		</div>

		<div ref="scroll" class="treatment-inner">

			<div class="treatment-table-row" data-name="title">

				<div class="treatment-table-label"></div>

				<div class="treatment-table-item" v-for="treatment in treatments" :key="treatment">
					
					{{ section.treatment[treatment].title }}

				</div>

			</div>

			<div class="treatment-table-row" :data-name="row" v-for="row in rows" :key="row">

				<div class="treatment-table-label">

					<template v-if="row === 'spine'">
						<small>{{ section.treatment.table.chances}}</small>
					</template>
					
					{{ section.treatment.table[row] }}
					
				</div>

				<div class="treatment-table-item" v-for="treatment in treatments" :key="treatment + row">

					<template v-if="row === 'issues' || row === 'effects'">

						<p v-for="(item, index) in section.treatment[treatment][row]" :key="index">{{ item.title }}</p>

					</template>

					<template v-if="row === 'spine' || row === 'hip' || row === 'other'">

						<com-info :info="5" class="treatment-info" v-if="row ==='spine'" />

						<div class="treatment-table-item-tick" :class="{'is-active': section.treatment[treatment][row] > 4, 'is-half': section.treatment[treatment][row] === 4.5}"></div>
						<div class="treatment-table-item-tick" :class="{'is-active': section.treatment[treatment][row] > 3, 'is-half': section.treatment[treatment][row] === 3.5}"></div>
						<div class="treatment-table-item-tick" :class="{'is-active': section.treatment[treatment][row] > 2, 'is-half': section.treatment[treatment][row] === 2.5}"></div>
						<div class="treatment-table-item-tick" :class="{'is-active': section.treatment[treatment][row] > 1, 'is-half': section.treatment[treatment][row] === 1.5}"></div>
						<div class="treatment-table-item-tick" :class="{'is-active': section.treatment[treatment][row] > 0, 'is-half': section.treatment[treatment][row] === 0.5}"></div>

					</template>

					<template v-if="row === 'title' || row === 'method' || row === 'frequency'">

						{{ section.treatment[treatment][row] }}
					
					</template>

				</div>

			</div>

			<div class="treatment-table-row" data-name="more">

				<div class="treatment-table-label">{{ section.treatment.table.note }}</div>

				<div class="treatment-table-item" v-for="treatment in treatments" :key="treatment">
					
					<com-button v-on:click="onMoreClick(treatment)">More info</com-button>

				</div>

			</div>

		</div>
		
	</div>

	<div class="treatment-none" v-if="!treatments.length">

		{{ section.treatment.none[(isSIGN) ? 'sign' : 'nogg'].title }}
		
	</div>

	<div class="treatment-foot" :class="{'is-sign': isSIGN, 'is-nogg': isNOGG}">

		{{ section.treatment.credit[(isSIGN) ? 'sign' : 'nogg'] }}

	</div>

	</template>

</com-segment>

</template>

<script>

import comSegment from './Segment'
import comMore from './treatment/More'
import comButton from './../../common/Button'
import comInfo from './../../common/section/form/Info'

export default {

	props: ['section'],

	components: {
		'com-segment': comSegment,
		'com-button': comButton,
		'com-more': comMore,
		'com-info': comInfo
	},

	data: function() {

		return {
			rows: ['spine', 'hip', 'effects', 'issues', 'method', 'frequency'],
			treatment: false,
			showOther: false,
			isStart: true
		}

	},

	created: function() {

		if (this.treatments.length === 1) {

			this.treatment = this.treatments[0]
		}

	},

	computed: {

		guideline: function() {

			return this.$store.getters['logic/variable'](this.section.treatment.guideline)

		},

		isSIGN: function() {

			return this.guideline === 2

		},

		isNOGG: function() {

			return this.guideline === 1

		},

		parsedPatientText: function() {

			var text = this.section.treatment.patient_text || ''

			return text.replace(/\[trigger=([^\]]+)\](.*?)\[\/trigger\]/g, function(match, key, label) {
				return '<a href="#" class="media-link" data-trigger="' + key + '">' + label + '</a>'
			})

		},

		otherDrugs: function() {

			return ['zoledronate', 'denosumab', 'abaloparatide', 'romosozumab', 'teriparatide']

		},

		treatments: function() {

			var treatments = []

			this.$_.each(this.section.treatment, function(treatment, key) {

				if (this.$_.contains([
					'bisphosphonates',
					'denosumab',
					'romosozumab',
					'teriparatide',
					'zoledronate',
					'abaloparatide'
				], key)) {

					treatments.push(key)
					
				}

			}.bind(this))

			return treatments

		}

	},

	methods: {

		onLeftClick: function() {

			this.$refs.scroll.scrollBy({
				left: -2000,
				behavior: 'smooth'
			})

			this.isStart = true

		},

		onRightClick: function() {

			this.$refs.scroll.scrollBy({
				left: 2000,
				behavior: 'smooth'
			})

			this.isStart = false

		},

		onCloseClick: function() {

			if (this.treatment && this.$isPatient && this.showOther) {

				this.treatment = false

			} else if (this.treatment && this.$isPatient) {

				this.treatment = false

			} else if (this.showOther) {

				this.showOther = false

			} else if (this.treatment && this.treatments.length > 1) {

				this.treatment = false

			} else {

				this.$emit('close')

			}

		},

		onPatientTextClick: function(e) {

			var target = e.target.closest('.media-link')

			if (target) {
				e.preventDefault()
				var key = target.getAttribute('data-trigger')

				if (key === 'other') {
					this.showOther = true
				} else {
					this.treatment = key
				}
			}

		},

		onMoreClick: function(treatment) {

			this.treatment = treatment

		}

	}
	
}

</script>

<style scoped>

.treatment p {
	color: #343434;
	font-size: 18px;
	line-height: 22px;
	font-weight: 400;
}

.treatment-table {	
	padding: 64px 0px;
}

.treatment-head {
	height: 40px;
	padding-left: 200px;
	display: grid;
	grid-template-columns: 40px 1fr 40px;
	margin-bottom: 20px;
}

.treatment-table.has-scroll .treatment-head-left {
	background-image: url(/img/section.foot.chevron.ee541775.svg);
    background-size: 20px 20px;
	background-position: 50% 50%;
	width: 40px;
	height: 40px;
	transform: rotate(90deg);
	background-repeat: no-repeat;
	background-color: #343434;
	border-radius: 50%;
	cursor: pointer;
}

.treatment-table.has-scroll .treatment-head-right {
	background-image: url(/img/section.foot.chevron.ee541775.svg);
    background-size: 20px 20px;
	background-position: 50% 50%;
	width: 40px;
	height: 40px;
	transform: rotate(-90deg);
	background-repeat: no-repeat;
	background-color: #343434;
	border-radius: 50%;
	cursor: pointer;
}

.treatment-head-title {
	text-align: center;
	text-transform: uppercase;
	font-size: 14px;
	line-height: 40px;
	font-weight: 500;
}

.treatment-inner {
	width: 100%;
}

.treatment-table.has-scroll .treatment-inner {
	overflow-x: auto;
}

.treatment-table.has-scroll:not(.is-start) .treatment-table-label:after {
	content: '';
	position: absolute;
	right: -40px;
	top: 0px;
	bottom: 0px;
	width: 40px;
	z-index: 3;
	background-color: #f6f6f6;
	display: block;
	-webkit-mask-image: linear-gradient(to right, white, transparent);
	mask-image: linear-gradient(to right, white, transparent);
}

.treatment-table.has-scroll:not(.is-end):after {
	content: '';
	position: absolute;
	left: calc(100% - 40px);
	top: 120px;
	bottom: 0px;
	width: 40px;
	background-color: #f6f6f6;
	display: block;
	-webkit-mask-image: linear-gradient(to left, white, transparent);
	mask-image: linear-gradient(to left, white, transparent);
}

.treatment-table-row {
	display: flex;
	flex-direction: row;
	margin-bottom: 4px;
}

.treatment-table-label {
	width: 200px;
	color: #343434;
	flex-shrink: 0;
	font-size: 16px;
	line-height: 26px;
	background-color: #f6f6f6;
	font-weight: 600;
	position: sticky;
	left: 0px;
	padding: 16px 0px;
	z-index: 4;
}

.treatment-table-label small {
	font-size: 10px;
	margin-bottom: 16px;
	display: block;
	text-transform: uppercase;
	line-height: 10px;
}

.treatment-table-item {
	min-width: 258px;
	flex-grow: 1;
	flex-shrink: 0;
	flex-basis: 0;
	padding: 16px;
	background-color: #fff;
	margin: 0px 4px;
}

.treatment-table-row[data-name="spine"],
.treatment-table-row[data-name="hip"] {
	margin-bottom: 0px;
}

.treatment-table-row[data-name="title"] .treatment-table-item {
	border-radius: 6px 6px 0px 0px;
	background-color: #343434;
	color: #fff;
	display: flex;
	align-items: center;
	font-size: 16px;
	line-height: 20px;
	font-weight: 600;
	text-align: center;
	justify-content: center;
}

.treatment-table-row[data-name="effects"] .treatment-table-item p,
.treatment-table-row[data-name="issues"] .treatment-table-item p {
	font-size: 16px;
	line-height: 26px;
	color: #343434;
	font-weight: 300;
	margin-bottom: 13px;
	text-align: center;
}

.treatment-table-row[data-name="effects"] .treatment-table-item p:last-child,
.treatment-table-row[data-name="issues"] .treatment-table-item p:last-child {
	margin-bottom: 0px;
}

.treatment-table-row[data-name="method"] .treatment-table-item,
.treatment-table-row[data-name="frequency"] .treatment-table-item {
	font-size: 16px;
	line-height: 26px;
	color: #343434;
	text-align: center;
	font-weight: 600;
}

.treatment-table-row[data-name="spine"] .treatment-table-item {
	padding-top: 42px;
}

.treatment-table-row[data-name="other"] .treatment-table-item {
	padding-bottom: 42px;
}

.treatment-table-row[data-name="spine"] .treatment-table-item,
.treatment-table-row[data-name="hip"] .treatment-table-item,
.treatment-table-row[data-name="other"] .treatment-table-item {
	display: flex;
	justify-content: center;
}

.treatment-table-row[data-name="more"] {
}

.treatment-table-row[data-name="more"] .treatment-table-label {
	font-size: 12px;
	letter-spacing: 1;
}

.treatment-table-row[data-name="more"] .treatment-table-item {
	text-align: center;
}

.treatment-table-item-tick {
	width: 26px;
	margin: 0px 2px;
	height: 26px;
	border-radius: 130px;
	background-color: #F6F6F6;
}

.treatment-table-item-tick.is-active {
	background-color: #F8A533;
	background-image: url(~@/assets/aid/common/icon.tick.svg);
	background-position: 50% 50%;
	background-repeat: no-repeat;
}

.treatment-table-item-tick.is-active.is-half {
	background-image: none;
	background-color: #F6F6F6;
}

.treatment-table-item-tick.is-active.is-half:before {
	content: '';
	display: block;
	position: absolute;
	left: 0px;
	top: 0px;
	height: 26px;
	width: 26px;
	background-color: #F8A533;
	z-index: 1;
	clip-path: polygon(50% 0, 100% 0, 100% 100%, 50% 100%);
	border-radius: 26px;
}

.treatment-table-item-tick.is-active.is-half:after {
	content: '';
	display: block;
	position: absolute;
	left: 0px;
	top: 0px;
	height: 26px;
	width: 26px;
	z-index: 2;
	background-image: url(~@/assets/aid/common/icon.tick.svg);
	background-position: 50% 50%;
	background-repeat: no-repeat;
	border-radius: 26px;
}

.treatment-none {
	padding: 64px 0px;
	font-size: 32px;
	line-height: 40px;
	font-weight: 600;
	text-align: center;
	color: #343434;
}

.treatment-foot {
	font-size: 12px;
	line-height: 20px;
	font-weight: 600;
	padding-right: 400px;
	min-height: 40px;
	background-position: 100% 50%;
	background-size: auto 40px;
	background-repeat: no-repeat;
}

.treatment-foot.is-sign {
	background-image: url(~@/assets/logo.sign.png);
}

.treatment-foot.is-nogg {
	background-image: url(~@/assets/logo.nogg.png);
}

.treatment-info {
	right: 20px;
    top: 50%;
}

.treatment-info >>> .info-wrapper {
	width: 356px;
	z-index: 100;
	right: -24px;
}

.treatment-info >>> .info-wrapper:before {
	right: 34px;
}


</style>

<style>

.treatment-patient-text {
	font-size: 18px;
	color: #343434;
	line-height: 28px;
	font-weight: 300;
}

.treatment-patient-text p { margin-bottom: 12px; }
.treatment-patient-text ul { padding-left: 20px; margin-bottom: 12px; list-style: disc; }
.treatment-patient-text li { margin-bottom: 4px; display: list-item; }

.treatment-patient-text .media-link {
	display: inline;
	color: #343434;
	font-weight: 600;
	text-decoration: underline;
	text-decoration-color: var(--aid-color);
	text-underline-offset: 3px;
	text-decoration-thickness: 2px;
	cursor: pointer;
	transition: color 300ms ease-in-out;
}

.treatment-patient-text .media-link:hover {
	color: var(--aid-color);
}

.treatment-other p {
	font-size: 18px;
	line-height: 28px;
	color: #343434;
	font-weight: 300;
	margin-bottom: 24px;
}

.treatment-other-list {
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
}

.treatment-other-item {
	padding: 10px 20px;
	background-color: #fff;
	border: 2px solid #ddd;
	border-radius: 24px;
	font-size: 14px;
	font-weight: 600;
	color: #343434;
	cursor: pointer;
}

.treatment-other-item:hover {
	border-color: var(--aid-color);
	background-color: var(--aid-color);
}

</style>
